import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import {
  ANALYTICS_SYNC_EVENT,
  isPerformanceTrackingAllowed,
  syncAnalytics,
} from "../../utils/analytics";

export default function SiteAnalytics() {
  const { pathname } = useLocation();
  const [enabled, setEnabled] = useState(isPerformanceTrackingAllowed);

  useEffect(() => {
    syncAnalytics();

    const onSync = (event) => {
      setEnabled(event.detail?.allowed ?? isPerformanceTrackingAllowed());
    };

    window.addEventListener(ANALYTICS_SYNC_EVENT, onSync);
    return () => window.removeEventListener(ANALYTICS_SYNC_EVENT, onSync);
  }, []);

  if (!enabled) return null;

  return (
    <Analytics
      route={pathname}
      path={pathname}
      beforeSend={(event) => (isPerformanceTrackingAllowed() ? event : null)}
    />
  );
}
